import { useCallback } from 'react';
import { isEmptyString, isFullName, validEmail, isConsumerDomain } from 'Shared/helpers';

export const USE_WORK_EMAIL_MESSAGE = 'Please use a work email';

export function composeValidators(...validators) {
  return value => validators.reduce((error, validator) => error || validator(value), undefined);
}

export function useValidator(validate, message) {
  return useCallback(value => validate(value, null, message), [message, validate]);
}

export function maxLength(length = 512) {
  return value => {
    if (isEmptyString(value)) return undefined;
    if (value.length > length) return `This field must not exceed ${length} characters`;
    return undefined;
  };
}

export function required(value, _, message = 'This field is required') {
  return value || value === 0 ? undefined : message;
}

export function requiredEditorText(value, _, message = 'This field is required') {
  return value?.getCurrentContent && value?.getCurrentContent()?.hasText() ? undefined : message;
}

export function requiredText(value, _, message = 'This field is required') {
  return isEmptyString(value) ? message : undefined;
}

export function multipleRequired(value, _, message = 'This field is required') {
  if (!value) return message;
  if (Array.isArray(value) && !value.length) return message;
  return undefined;
}

export function validEmailOrEmptyRequired(value, _, message = 'Please enter a valid email') {
  if (!isEmptyString(value) && !validEmail(value?.trim())) return message;
  if (!isEmptyString(value) && isConsumerDomain(value)) return USE_WORK_EMAIL_MESSAGE;
  return null;
}

export function validEmailRequired(value, _, message = 'Please enter a valid email') {
  if (!validEmail(value?.trim())) return message;
  if (!isEmptyString(value) && isConsumerDomain(value)) return USE_WORK_EMAIL_MESSAGE;
  return null;
}

export function nonEmptyStringRequired(value, _, message = 'Please enter your first and last name') {
  if (isEmptyString(value)) return message;
  return null;
}

export function nonConsistsOfAllSpacesStringRequired(value, _, message = 'Please enter a valid data') {
  if (value && isEmptyString(value)) return message;
  return null;
}

export function fullNameRequired(value, _, message = 'Please enter your first and last name') {
  if (!value) return message;
  if (!isFullName(value)) return message;
  return undefined;
}
